// Should a case / policy page show the "Latest notes" strip at its bottom
// for this viewer? Pure on purpose so the rule is unit-tested without React.
//
// DECISION (Andrea, 2026-10-12): this is per-role tailoring, not an OS-wide
// move. The viewers who asked are servicing roles (Planning and Insurance
// policy managers), who live in a case's notes all day. A Mortgage or
// Realty advisor working a file would just see a strip they never wanted
// under it, so for them it starts off. Anyone can flip it from the notes
// dock, and a saved choice always beats this default.

const SERVICING_COMPANIES = new Set(["planning", "insurance"]);

/**
 * `choice` is the viewer's saved setting (null = never chose).
 * `editableCompanySlugs` is `user.editable_company_slugs` (undefined while
 * the session loads; an empty list or "all" reads as an unscoped account).
 */
export function resolveLatestNotesAtBottom(
  choice: boolean | null,
  editableCompanySlugs: readonly string[] | "all" | null | undefined,
): boolean {
  if (choice !== null) return choice;
  if (!Array.isArray(editableCompanySlugs) || editableCompanySlugs.length === 0) return false;
  // Every company the viewer works in is a servicing one. Jake (Financial +
  // Planning) and the cross-company roles are not, and can opt in.
  return editableCompanySlugs.every((slug) => SERVICING_COMPANIES.has(slug));
}
